import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  MenuItem,
  TextField,
} from "@mui/material";
import api from "../../utils/api";
import { toast } from "react-toastify";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "white",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

const ChangeKeywordCategoryModal = ({
  open,
  onClose,
  keyword,
  setRender,
  render,
}) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}keyword-category/all`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      setCategories(res.data);
    } catch (err) {
      toast.error("Unable to fetch categories");
    }
  };

  const updateCategory = async () => {
    if (!selectedCategoryId) {
      toast.error("Please select a category");
      return;
    }

    try {
      await api.put(
        `${process.env.REACT_APP_BASE_URL}keyword-category/assign/${keyword._id}`,
        { newCategoryId: selectedCategoryId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("Category updated successfully");
      setRender(!render);
      onClose();
    } catch (err) {
      toast.error("Failed to update keyword category");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" mb={2} textAlign="center">
          Assign Category
        </Typography>

        <TextField
          select
          fullWidth
          label="Select Category"
          value={selectedCategoryId}
          onChange={(e) => setSelectedCategoryId(e.target.value)}
        >
          {categories.map((cat) => (
            <MenuItem key={cat._id} value={cat._id}>
              {cat.categoryName}
            </MenuItem>
          ))}
        </TextField>

        <Button
          fullWidth
          variant="contained"
          onClick={updateCategory}
          sx={{ mt: 3, backgroundColor: "#1B3C73" }}
        >
          Assign
        </Button>
      </Box>
    </Modal>
  );
};

export default ChangeKeywordCategoryModal;
